export default __webpack_public_path__ + "static/media/Step1_Main_Board.2ff5a632.gif";